import _ from 'underscore'
import Logger from 'Logger'
import { eventBus } from '../utils/eventBus'
import { multiFactorAuthenticate } from '../utils/MFA'
import { mallClose } from '../utils/mallClose'

/**
 * 상품 상세 설명 팝업 트리거
 * @param {Object} options
 * @param {String} options.template - 템플릿 선택 기본적으로 'goodsDetail'
 * @param {String} options.title - 타이틀
 * @param {String} options.message - 상단 텍스트
 * @param {String} options.detailImgUrl - 상품 설명 이미지
 * @param {String} options.detail - 하단 상품 사용 설명
 * @param {Function} options.onConfirm - 확인 콜백
 * @param {Function} options.onClose: - 취소 콜백
 * @param {String} options.closeText: '취소'
 * @param {String} options.confirmText: '확인'
 */
export function goodsDetailShow(options) {
  var popupData = _.extend(options, {
    template: 'goodsDetail',
  })
  eventBus.trigger('$popupShow', popupData)
}

/**
 * 일반 설명 팝업 취소, 확인 버튼은 text 파라미터를 넘거야 노출 됨
 * @param {Object} options
 * @param {'message' | 'goodsDetail' | 'receipt' | 'moneyLimitInfo'} options.template
 * @param {String} options.title - 타이틀
 * @param {String} options.message - 텍스트
 * @param {Function} options.onConfirm - 확인 콜백
 * @param {Function} options.onCancel - 취소 콜백
 * @param {Function} options.onClose: - 닫기 콜백
 * @param {String} options.closeText: '닫기'
 * @param {String} options.cancelText: '닫기'
 * @param {String} options.confirmText - '확인'
 * @param {String} options.confirmBtnColor - gray | red & small-txt
 * @param {String} options.closeBtnColor - gray | red
 * @param {String} options.cancelBtnColor - gray | red
 */
export function popShow(options) {
  var popupData = _.extend(options)
  eventBus.trigger('$popupShow', popupData)
}

/**
 * @param {payOptions} options- 해달 콜력션에 상품 리스트 model.json
 * 구매팝업  보안 서비스 여부 확인하고 결제 팝업 오픈한다.
 */
export function pay(options) {
  // NOTE: mock
  // eventBus.trigger('$pay', options)
  // return

  multiFactorAuthenticate()
    .then(function () {
      eventBus.trigger('$pay', options)
    })
    .catch(function (err) {
      Logger.info('MFA catch', err)
      mallClose()
    })
}
